module.exports = __webpack_public_path__ + "static/iPhone-3-5aa33ee2dc0f47c9642804d8d3724bfc.png";